var isFunction = require('./function');

module.exports = function isStamp(arg) {
  return isFunction(arg) && isFunction(arg.compose);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/is/stamp.js
// module id = 94
// module chunks = 0